// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oGgr","clinicsSelect":"styles_clinicsSelect__hMPk9"};